/**
 * شعار iConTravel الرسمي — يُعرض بالملف كما هو (بلا إعادة تصميم أو تلوين أو قص).
 * `object-contain` + `w-auto` تحافظان على نسبة الصورة الأصلية على كل المقاسات.
 *
 * **الملف صار 1000×800** (27/09/2026، قرار المالك «سريع دايمًا»): كان 2000×1600 بحجم 1.4 ميجا يُحمَّل مع أول
 * فتحٍ على كل جهاز، والشاشة لا تعرضه أكبر من ~110px. نصفُ المقاس بالنسبة نفسها والهوامش الشفّافة نفسها
 * (الأصل في تاريخ git قبل هذا التاريخ). وللشاشة WebP (~80KB) وللطباعة PNG — المتصفّح يختار.
 *
 * **انتبه قبل تغيير المقاس**: الرسم نفسه مربّع في وسط اللوحة، وحوله هامش شفّاف مقصود؛ فالمقاس الذي
 * تكتبه في CSS هو مقاس **اللوحة** لا مقاس ما تراه العين:
 *
 *     ارتفاع الرسم المرئي = ارتفاع الصندوق × ٠٫٧٩٨       (1277 ÷ 1600 في الأصل)
 *     عرض الصندوق        = ارتفاع الصندوق × ١٫٢٥        (2000 ÷ 1600)
 *
 * أي أن `h-[4.5rem]` (72px) لا تُري المستخدم إلا **57px**. فمن أراد رسمًا بارتفاع 88px يكتب صندوقًا
 * بارتفاع 110px (‎88 ÷ 0.798‏). ولا يُقصّ الهامش بحيلة: الصندوق يكبر بقيمته الحقيقية فيكبر معه الرسم.
 */
export function Logo({ className = 'h-8', priority = false }: { className?: string; priority?: boolean }) {
  return (
    <picture className="contents">
      <source type="image/webp" srcSet="/assets/icontravel-logo.webp" />
      <img
        src="/assets/icontravel-logo.png"
        alt="iConTravel"
        width={1000}
        height={800}
        loading={priority ? 'eager' : 'lazy'}
        decoding="async"
        className={`w-auto shrink-0 object-contain ${className}`}
      />
    </picture>
  );
}
